
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class QRywcSpec1411Dialog extends Serenity.EntityDialog<QRywcSpecRow, any> {
        // static _dfromDate: string;
        // static _dendDate: string;
        protected getFormKey() { return QRywcSpec1411Form.formKey; }
        protected getIdProperty() { return QRywcSpecRow.idProperty; }
        protected getLocalTextPrefix() { return QRywcSpecRow.localTextPrefix; }
        protected getNameProperty() { return QRywcSpecRow.nameProperty; }
        protected getService() { return QRywcSpecService.baseUrl; }
        protected getDeletePermission() { return QRywcSpecRow.deletePermission; }
        protected getInsertPermission() { return QRywcSpecRow.insertPermission; }
        protected getUpdatePermission() { return QRywcSpecRow.updatePermission; }

        protected form = new QRywcSpec1411Form(this.idPrefix);

        constructor() {
            super();
            

            // this.form.ReportId.changeSelect2(e => {
            //     let ex = Q.toId(this.form.ReportId.value)
            //     // let fo =  this.form.ReportId.value
            //     // console.log(ex)
            //     // console.log(QRyreportRow.getLookup().itemById[fo].DataStructureName)

            //     this.form.DataStructureName.value = QRyreportRow.getLookup().itemById[ex].DataStructureName;
            //     this.form.ReportName.value = QRyreportRow.getLookup().itemById[ex].ReportName;
            //     this.form.UrlReport.value = QRyreportRow.getLookup().itemById[ex].UrlReport;

            //     // Serenity.ComponentModel
                
               
            // });


            // this.form.ListFg.changeSelect2(e => {
            //     let ex = Q.toId(this.form.ListFg.value)
            //     if(ex == 2){
            //         Serenity.EditorUtils.setReadOnly(this.form.PluCode, true);

            //         Serenity.EditorUtils.setReadOnly(this.form.StyleCode, false);
            //         this.form.SellUnitPrice1.value = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice1;
                   
            //         this.form.SupplCode.value = null
            //         this.form.PluCode.value = null
            //     }
            // });

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.push(
                {
                    title: Q.text(" Continue"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-report',
                    icon: 'fa fa-check text-green',
                    onClick: () => {
                        this.save((response) => {
                            // this.dialogClose();
                        
                           
                        let url = this.form.UrlReport.value;
                        window.location.href = url;
                        });
                        
                        //window.open(url, '_blank');
                        // *** do something on click if you want **

                    },
                }
            );
            buttons.push(
                {
                    title: Q.text(""),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa fa-close text-red',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.form.DateBegin.value = (new Date(Date.now())).toDateString();
            this.form.DateEnd.value = (new Date(Date.now())).toDateString();
            // this.form.ShopId.value = null;

            // this.form.PromoCampaign.value = null;
            // this.form.PluCode.value = null;
            this.form.CatCode.value = null;
            this.form.SubCat1Code.value = null;
            this.form.SubCat2Code.value = null;
            this.form.BrandCode.value = null;
            this.form.StyleId.value = null;
            this.form.ColorId.value = null;
            this.form.SizeId.value = null;
            this.form.TasteId.value = null;
            this.form.MatTypeId.value = null;
            this.form.SupplId.value = null;
            // this.form.ConsignFg.value = null;
           
       
            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }
       
                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            self.element.find(".panel-titlebar").html("Report Filter");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                             self.element.parent().find(".panel-titlebar").html("Report Filter");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                           // self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            
        }
        

    //     protected afterLoadEntity() {
    //         super.afterLoadEntity();

    //         if(this.isEditMode){
    //             let x = this.form.ReportId.value
    //             if ( x ="1302"){
    //                 this.R1302
    //             }
                
    //         }


    //         //ตัวอย่าง
    // //         protected afterLoadEntity() {
    // //             super.afterLoadEntity();
    
    // //             if (this.isNew)
    // //             {
    // //                 this.form.<yourField>.getGridField().toggle(false);
    // //             }
    // //             else
    // //             {
    // //                 this.form.<yourField>.getGridField().toggle(true);
    // //             }
    // // }

    //     }
        
    //     private R1302() {
    //                 this.form.PluCode.getGridField().toggle(false);
    //                 this.form.CatCode.getGridField().toggle(false);
    //                 this.form.SubCat1Code.getGridField().toggle(false);
    //                 this.form.SubCat2Code.getGridField().toggle(false);
    //                 this.form.BrandCode.getGridField().toggle(false);
    //                 this.form.StyleId.getGridField().toggle(false);
    //                 this.form.SizeId.getGridField().toggle(false);
    //                 this.form.TasteId.getGridField().toggle(false);
    //                 this.form.MatTypeId.getGridField().toggle(false);
    //                 this.form.SupplId.getGridField().toggle(false);
            
    //     }
    }

    
}